import { Navigate, Outlet, useLocation } from 'react-router'
import { useAuth } from '@/features/auth/hooks/useAuth'
import { useIdleTimeout } from '@/features/auth/hooks/useIdleTimeout'
import { SLIM_ROUTES } from '@/shared/routes'

export const ProtectedRoute = () => {
  const { isAuthenticated, isInitializing } = useAuth()
  const location = useLocation()
  useIdleTimeout()

  if (isInitializing) return null

  if (!isAuthenticated) {
    return (
      <Navigate
        to={SLIM_ROUTES.LOGIN}
        replace
        state={{ from: location.pathname }}
      />
    )
  }
  return <Outlet />
}
